import access from "@/mixin/functions/access";

export default {
    methods: {
        canManageDiscounts: () => access.canManageDiscounts(),
        canManageServices: () => access.canManageServices(),
        canSeeServiceHistory: () => access.canSeeServiceHistory(),
        canManageTaxes: () => access.canManageTaxes(),
        canSale: () => access.canSale(),
        canSeeSaleHistory: () => access.canSeeSaleHistory(),
        canStoreKeeping: () => access.canStoreKeeping(),
        canManageProducts: () => access.canManageProducts(),
        canPurchaseProducts: () => access.canPurchaseProducts(),
        canSeeProductPurchasesHistory: () => access.canSeeProductPurchasesHistory(),
        canManageCustomers: () => access.canManageCustomers(),
        canManageEmployees: () => access.canManageEmployees(),
        canSeeCustomerDebts: () => access.canSeeCustomerDebts(),
        canManageCompany: () => access.canManageCompany(),
        canSeeCompanyInfo: () => access.canSeeCompanyInfo(),
        hasRoleCeo: () => access.hasRoleCeo(),
        hasRoleAdmin: () => access.hasRoleAdmin(),
        hasRoleCeoOrAdmin: () => access.hasRoleCeoOrAdmin(),
        hasRole: (roleName) => access.hasRole(roleName),
        hasAccessToUnderCeoLevel: (roleName) => access.hasAccessToUnderCeoLevel(roleName),
        canManagerSuppliers: () => access.canManagerSuppliers(),
        canManageKpis: () => access.canManageKpis(),
        canSeeSupplierDebts: () => access.canSeeSupplierDebts(),
        canDeleteSaleHistory: () => access.canDeleteSaleHistory(),
    }
}